import { selectChartConfigSettings } from "../../selectors/chart";
import { selectActiveChartId } from "../../selectors/chart";
import { useSelector } from "react-redux";
type SettingOption = {
    label: string
    actionType: string
    onClick?: () => void
    isChecked?: boolean
    field: keyof StatusLineSettingsType
    settingId?: string
}
export type StatusLineSettingsType = {
    logo?: boolean;
    showSymbolName?: boolean;
    showOHLC?: boolean;
    showBarChange?: boolean;
    showLastDayChange?: boolean;
    indicatorTitle?: boolean;
    indicatorInputs?: boolean;
    indicatorValues?: boolean;
};

export const useQuickSearchSettings = (): SettingOption[] => {
    const viewKey = useSelector(selectActiveChartId)
    const statusLineSettings = useSelector(selectChartConfigSettings(viewKey))
    return [
        { label: "Chart Logo", actionType: "setting", field: "logo", settingId: 'settingCheckbox', isChecked: !!statusLineSettings?.logo },
        { label: "Chart Title", actionType: "setting", field: "showSymbolName", settingId: 'settingCheckbox', isChecked: !!(statusLineSettings?.showSymbolName ?? true) },
        { label: "Chart OHLC Value", actionType: "setting", field: "showOHLC", settingId: 'settingCheckbox', isChecked: !!(statusLineSettings?.showOHLC ?? true) },
        { label: "Bar Change Value", actionType: "setting", field: "showBarChange", settingId: 'settingCheckbox', isChecked: !!(statusLineSettings?.showBarChange ?? true) },
        { label: "Last Day Change", actionType: "setting", field: "showLastDayChange", settingId: 'settingCheckbox', isChecked: !!statusLineSettings?.showLastDayChange },
        { label: "Indicator Title", actionType: "setting", field: "indicatorTitle", settingId: 'settingCheckbox', isChecked: !!(statusLineSettings?.indicatorTitle ?? true) },
        { label: "Indicator Inputs", actionType: "setting", field: "indicatorInputs", settingId: 'settingCheckbox', isChecked: !!statusLineSettings?.indicatorInputs },
        { label: "Indicator Values", actionType: "setting", field: "indicatorValues", settingId: 'settingCheckbox', isChecked: !!(statusLineSettings?.indicatorValues ?? true) }
    ]
}